import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, InstagramLogo, FacebookLogo, WhatsappLogo, MapPin, EnvelopeSimple, Phone } from "@phosphor-icons/react";

const Footer = ({ config }) => {
  const phone = config?.whatsapp_phone || "233592208031";
  const email = config?.contact_email || "info@obrasafe.org";

  return (
    <footer data-testid="site-footer" className="bg-black border-t border-white/10 mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="flex items-center gap-2 mb-4">
            <span className="bg-[#FFC107] text-black w-9 h-9 flex items-center justify-center">
              <ShieldCheck size={22} weight="fill" />
            </span>
            <span className="font-display text-2xl font-black uppercase tracking-tight">
              OBRA<span className="text-[#FFC107]">SAFE</span>
            </span>
          </div>
          <p className="text-sm text-zinc-400 leading-relaxed max-w-sm">
            Engineered security for Ghana&apos;s drivers, riders, and dispatch
            heroes. From okada disc locks to car immobilisers — we keep your
            ride yours.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a
              href={`https://wa.me/${phone}`}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp"
              className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-[#25D366] hover:text-white hover:border-[#25D366] transition-colors"
              aria-label="WhatsApp"
            >
              <WhatsappLogo size={18} weight="bold" />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="w-10 h-10 border border-white/20 flex items-center justify-center hover:text-[#FFC107] hover:border-[#FFC107] transition-colors"
              aria-label="Instagram"
            >
              <InstagramLogo size={18} weight="bold" />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-facebook"
              className="w-10 h-10 border border-white/20 flex items-center justify-center hover:text-[#FFC107] hover:border-[#FFC107] transition-colors"
              aria-label="Facebook"
            >
              <FacebookLogo size={18} weight="bold" />
            </a>
          </div>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#FFC107] mb-4">
            Shop
          </h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/products?cat=motorcycle" className="hover:text-[#FFC107]">Motorcycle</Link></li>
            <li><Link to="/products?cat=car" className="hover:text-[#FFC107]">Car</Link></li>
            <li><Link to="/products?cat=bicycle" className="hover:text-[#FFC107]">Bicycle</Link></li>
            <li><Link to="/products?cat=home" className="hover:text-[#FFC107]">Home &amp; Shop</Link></li>
            <li><Link to="/products?cat=tracker" className="hover:text-[#FFC107]">GPS Trackers</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#FFC107] mb-4">
            Company
          </h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className="hover:text-[#FFC107]">About</Link></li>
            <li><Link to="/contact" className="hover:text-[#FFC107]">Contact</Link></li>
            <li><a href="#faq" className="hover:text-[#FFC107]">FAQ</a></li>
            <li><Link to="/admin" className="hover:text-[#FFC107]">Admin</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#FFC107] mb-4">
            Visit / Reach Us
          </h4>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li className="flex items-start gap-3">
              <MapPin size={18} className="text-[#FFC107] mt-0.5" />
              <a
                href="https://maps.app.goo.gl/p1RMdsKmfeaXdfd8A"
                target="_blank"
                rel="noreferrer"
                className="hover:text-[#FFC107]"
              >
                Lionsgate Residence, Accra, Ghana
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={18} className="text-[#FFC107]" />
              <a href={`tel:+${phone}`} className="hover:text-[#FFC107]">+{phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <EnvelopeSimple size={18} className="text-[#FFC107]" />
              <a href={`mailto:${email}`} className="hover:text-[#FFC107]">{email}</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row gap-4 items-center justify-between text-xs text-zinc-500 uppercase tracking-widest">
          <span>© {new Date().getFullYear()} ObraSafe Ghana. All rights reserved.</span>
          <span className="font-mono-accent">PROUDLY ENGINEERED IN ACCRA</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
